<template>
  <div>
    <nav id="navbar_top" class="navbar navbar-light bg-white">
      <a class="navbar-brand ms-4" href="#">PedidosApp</a>
      <div class="justify-content-end">
        <a href="#" class="ml-auto me-6 mr-1">
          <span class="svg-icon svg-icon-1">
            <inline-svg src="media/icons/duotune/ecommerce/ecm002.svg" />
          </span>
        </a>
        <a href="#" class="ml-auto me-6 mr-1">
          <span class="svg-icon svg-icon-1">
            <inline-svg src="media/icons/duotune/communication/com013.svg" />
          </span>
        </a>
      </div>
    </nav>
    <div class="separator"></div>
    <div id="nav-search" v-bind:class="[active ? 'fixed-top shadow' : '']">
      <div class="bg-white pt-2">
        <div class="">
          <div>
            <div class="d-flex align-items-center my-1 mx-4">
              <span class="svg-icon svg-icon-1 position-absolute ms-6">
                <inline-svg src="media/icons/duotune/general/gen004.svg" />
              </span>
              <input
                v-model="searchValue"
                type="text"
                class="form-control ps-15 pe-16"
                placeholder="Pesquisar Produtos"
                id="txtPesquisa"
                @input="onSearch($event.target.value)"
              />
              <div
                class="position-absolute end-0 me-5"
                kt-search-element="toolbar"
              >
                <button
                  type="button"
                  class="btn btn-icon btn-active-light"
                  @click="limparPesquisa()"
                  v-if="this.searchValue"
                >
                  <span class="svg-icon svg-icon-1">
                    <inline-svg src="media/icons/duotune/arrows/arr088.svg" />
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div>
            <div class="mt-4">
              <div class="scrolling-wrapper">
                <template v-for="grupo in grupos" :key="grupo">
                  <div class="card-menu" @click="selecionarGrupo(grupo)">
                    <div
                      :id="grupo.id"
                      :ref="'#menu-' + grupo.id"
                      class="card-menu-itens"
                    >
                      <a>
                        <h4 class="card-menu-link">
                          {{ grupo.descricao }}
                        </h4>
                      </a>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <nav
      class="navbar navbar-light bg-white rounded-top shadow-lg navbar-expand d-md-none d-lg-none d-xl-none fixed-bottom p-0"
    >
      <ul class="navbar-nav nav-justified w-100">
        <li class="nav-item">
          <a href="#" class="nav-link text-center">
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/general/gen001.svg" />
            </span>
            <span class="small d-block mt-2">Início</span>
          </a>
        </li>
        <li class="nav-item">
          <a @click="pesquisarProdutos()" class="nav-link text-center">
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/general/gen021.svg" />
            </span>
            <span class="small d-block mt-2">Pesquisar</span>
          </a>
        </li>
        <li class="nav-item">
          <a href="#" class="nav-link text-center">
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/ecommerce/ecm002.svg" />
            </span>
            <span class="small d-block mt-2">Carrinho</span>
          </a>
        </li>
        <li class="nav-item">
          <a href="#" class="nav-link text-center">
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/communication/com013.svg" />
            </span>
            <span class="small d-block mt-2">Perfil</span>
          </a>
        </li>
      </ul>
    </nav>
    <div class="container-xxl">
      <template v-for="grupo in grupos" :key="grupo">
        <section :id="grupo.id" v-if="grupo.Produto.length > 0">
          <!-- <h2
              :id="grupo.id"
              :ref="'#' + grupo.id"
              class="my-4 anchor fw-bold h2-group"
            >
              {{ grupo.descricao }}
            </h2> -->
          <h2 :ref="'#' + grupo.id" class="my-4 anchor fw-bold h2-group">
            {{ grupo.descricao }}
          </h2>
          <template v-for="item in grupo.Produto" :key="item">
            <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
              <a
                @click="modalProduto(true)"
                data-bs-toggle="modal"
                data-bs-target="#kt_modal_produto_editar"
              >
                <div class="card shadow-sm card-bordered mb-4 bg-hover-lighten">
                  <div class="d-flex align-items-center">
                    <div
                      v-if="item.imagem"
                      class="symbol flex-shrink-0 m-4 align-self-center"
                    >
                      <div
                        class="symbol-label fs-2 fw-bold bg-light-dark"
                        :style="{
                          'background-image': `url(${
                            this.$utils.getUrl() + item.imagem
                          })`,
                        }"
                      ></div>
                    </div>
                    <div v-else class="symbol flex-shrink-0 m-4">
                      <span
                        class="symbol-label h-85px w-100px align-self-center"
                      >
                        <img
                          src="media/svg/files/blank-image.svg"
                          class="img-fluid h-50 rounded-2"
                          alt=""
                        />
                      </span>
                    </div>
                    <div
                      class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3"
                    >
                      <span
                        class="fs-2 text-gray-800 text-hover-primary fw-bolder mt-3"
                      >
                        {{ item.nome }}
                      </span>
                      <span
                        class="text-gray-600 fs-5 my-1 mt-2 mb-2 text-break"
                      >
                        {{ item.descricao }}
                      </span>
                      <span
                        class="fs-4 text-dark-75 font-weight-bolder mb-3 mt-4"
                      >
                        R$ {{ this.$utils.formatarNumero(item.preco) }}
                      </span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </template>
        </section>
      </template>
      <div style="height: 360px"></div>
    </div>
  </div>
  <ProdutosModal
    :show="exibirProduto"
    @exibirModalProduto="modalProduto"
  ></ProdutosModal>
</template>

<script>
import { mapState } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import utils from "@/utils";
import ProdutosModal from "../market/ProdutoModal.vue";

export default {
  computed: {
    ...mapState("auth", ["user"]),
  },
  components: {
    ProdutosModal,
  },
  methods: {
    modalProduto(exibir) {
      this.exibirProduto = exibir;
    },
    async carregarGrupos() {
      this.isLoading = true;
      var page = (this.pagination.page - 1) * this.pagination.rowsPerPage;

      var filtro =
        "?&$expand=produto($select=id,imagem,nome,descricao,preco,ativo" +
        this.filterOData +
        ";$orderby=ordem,nome asc)&$orderby=descricao";

      await this.$store.dispatch("grupo/getGrupoOData", filtro).then(
        async (ret) => {
          this.pagination.total = ret["@odata.count"];
          this.grupos = ret.value;

          // if (this.grupos !== null) {
          //   if (this.grupos.length > 0) {
          //     this.selecionarGrupo(this.grupos[0]);
          //   }
          // }
        },
        (error) => {
          if (error !== "") {
            console.log(error);
            Swal.fire({
              text: error.Message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Ok",
              customClass: {
                confirmButton: "btn fw-bold btn-danger",
              },
            });
          }
        }
      );
      this.isLoading = false;
    },
    async carregarProdutos() {
      this.isLoading = true;
      var page = (this.pagination.page - 1) * this.pagination.rowsPerPage;

      var filtro =
        "?&$count=true&$skip=" +
        page +
        "&$top=" +
        this.pagination.rowsPerPage +
        "&$select=id,nome,descricao,ativo,guid,cod_referencia,ean,imagem,preco,preco_promocao&$orderby=nome";

      if (this.filterOData !== "" && this.filterOData !== undefined) {
        filtro += this.filterOData;
      }

      await this.$store.dispatch("produto/getProdutoOData", filtro).then(
        async (ret) => {
          this.pagination.total = ret["@odata.count"];
          this.produtos = ret.value;
        },
        (error) => {
          if (error !== "") {
            console.log(error);
            Swal.fire({
              text: error.Message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Ok",
              customClass: {
                confirmButton: "btn fw-bold btn-danger",
              },
            });
          }
        }
      );
      this.isLoading = false;
    },
    async scrollMenu() {
      //this.$nextTick(() => {this.startVeryLongCalculation()})
      let el = this.$refs[this.scrollRefMenu];
      if (el) {
        el[0].scrollIntoView({
          block: "center",
          inline: "center",
        });
      }
    },
    async scrollGrupo() {
      let el = this.$refs[this.scrollRefGrupo];
      if (el) {
        el[0].scrollIntoView({
          behavior: "smooth",
        });
      }
    },
    async onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.filterOData =
          ";$filter=contains(nome, '" +
          pesquisa +
          "') or contains(descricao, '" +
          pesquisa +
          "')";
      } else {
        this.filterOData = "";
      }
      setTimeout(window.scrollTo(0, 0), 1000);
      await this.carregarGrupos();
    },
    async limparPesquisa() {
      this.filterOData = "";
      this.searchValue = "";
      await this.carregarGrupos();
    },
    async selecionarGrupo(grupo) {
      window.removeEventListener("scroll", this.onScroll);

      this.grupoSelecionado = grupo.id;

      this.scrollRefMenu = "#menu-" + grupo.id;
      await this.scrollMenu();

      this.scrollRefGrupo = "#" + grupo.id;
      await this.scrollGrupo();

      window.addEventListener("scroll", this.onScroll);
    },
    pesquisarProdutos() {
      let txtPesquisa = document.getElementById("txtPesquisa");
      if (txtPesquisa) {
        txtPesquisa.focus();
      }
    },
    onScroll() {
      const sectionItems = document.querySelectorAll("section");
      const menuItems = document.querySelectorAll("div .card-menu-itens");

      let navBar = document.getElementById("nav-search");
      //let navBar = document.getElementById("navbar_top");
      if (window.scrollY > navBar.offsetTop) {
        this.active = true;
      } else {
        this.active = false;
      }

      var current = "";
      if (sectionItems) {
        sectionItems.forEach((section) => {
          const sectionTop = section.offsetTop;
          if (window.scrollY >= sectionTop - 125) {
            current = section.getAttribute("id");
          }
        });
      }

      if (menuItems) {
        menuItems.forEach((item) => {
          item.classList.remove("card-menu-selected");
          if (item.getAttribute("id") === current) {
            item.classList.add("card-menu-selected");

            // var idMenu = "#menu-" + parseInt(item.getAttribute("id"));
            // let el = this.$refs[idMenu];
            // if (el) {
            // el[0].scrollIntoView({
            //   block: "center",
            //   inline: "center",
            // });
            // }
          }
        });
      }
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.carregarGrupos();
    window.addEventListener("scroll", this.onScroll);
  },
  data() {
    return {
      exibirProduto: false,
      observer: null,
      scrollRefMenu: null,
      scrollRefGrupo: null,
      grupoSelecionado: null,
      active: false,
      filterOData: "",
      searchValue: "",
      isLoading: false,
      grupos: [],
      produtos: [],
      pagination: {
        page: 1,
        rowsPerPage: 20,
        total: 0,
      },
    };
  },
};
</script>

<style>
.scrolling-wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}
.scrolling-wrapper::-webkit-scrollbar {
  display: none;
}
.card-menu {
  display: inline-block;
  height: 40px;
  background-color: white;
}
.card-menu-itens {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  border-bottom: 3px solid transparent;
}
.card-menu-selected {
  border-bottom: 3px solid #bd5035;
  transition: all 50ms ease-in-out;
}
.card-menu-link {
  margin: 0 15px;
  color: #505154;
}
.card-menu-link:hover {
  margin: 0 15px;
  color: #1b1b1d;
}
.h2-group {
  scroll-margin-top: 120px;
}
</style>
